// React i hooks
import { useSelector } from "react-redux";

// API servisi
import { getActiveUser } from "services/api/users";

// UI komponente
import { PageHeader } from "ui/components/PageHeader";
import { PageTitle } from "ui/components/PageTitle";
import { Breadcrumb } from "ui/components/Breadcrumb";

// Lokalne komponente
import TabMenu from "./components/TabMenu/TabMenu";
import AccountDetailCard from "./components/AccountDetailCard/AccountDetailCard";

const AccountPage = () => {
  const { user } = useSelector(getActiveUser);

  if (!user) return <></>;

  return (
    <>
      <div className="">
        <div className="bg-white rounded-t-md">
          <PageHeader>
            <PageTitle
              title="Moj račun"
              icon="/media/icons/setting.svg"
              iconColor="stroke-[#edeef8]"
            />
            <Breadcrumb />
          </PageHeader>
          <TabMenu />
        </div>
        <div className="px-4 py-4">
          <AccountDetailCard />
        </div>
      </div>
    </>
  );
};

export default AccountPage;
